import * as React from 'react';
import {
  Routes,
  Route,
  Link as LinkRoute,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
} from "react-router-dom";
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Tooltip from '@mui/material/Tooltip';


// import NumberField from './NumberField';

// import { Unstable_NumberInput as NumberInput } from '@mui/base/Unstable_NumberInput'
// import {
//   Unstable_NumberInput as BaseNumberInput,
//   NumberInputProps,
//   numberInputClasses,
// } from '@mui/base/Unstable_NumberInput';


// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
// import TableRow from '@mui/material/TableRow';
// import TableSortLabel from '@mui/material/TableSortLabel';

import { DataGrid, 
  GridRowsProp, 
  GridColDef, 
  GridColumnHeaderParams, 
  gridClasses,
  GridRowSelectionModel,
  GridCallbackDetails,
  useGridApiRef,
  gridPaginatedVisibleSortedGridRowIdsSelector,
  gridPageSelector,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
  GridEventListener,
  GridFooter,
  useGridEvent,
  GridRowId,
  GridCellModes,
  GridCellModesModel,
  GridCellParams,
} from '@mui/x-data-grid';

import Toolbar from '@mui/material/Toolbar';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import SaveIcon from '@mui/icons-material/Save';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { alpha } from '@mui/material/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import FilledInput from '@mui/material/FilledInput';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import FormGroup from '@mui/material/FormGroup';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import NativeSelect from '@mui/material/NativeSelect';
import MenuItem from '@mui/material/MenuItem';
import useLocalStorageState from 'use-local-storage-state'
import {useAuth} from '../../context/AuthContext'

import theme from '../../theme';

import {IVehWarrInfoRow,IVehWarrInfoResponse,IPrAvResponse,IPostWarrClaimResponse,IPostWarrClaimResponseData} from '../PageInterfaces'
//import {WarrOpsContextProvider, WarrOpsContext, useWarrOpsContext} from '../../context/WarrOpsContext'
import {
  WarrOpsCodesContextProvider,
  WarrOpsCodesContext, 
  useWarrOpsCodesContext,
  OpCodesItemType,
  OpCodeCategType,
  opscodesDataType,
  WarrOpsCodesResponseType,
  // warrantyoperationsType,
  WarrOpType,
  WarrOpCategoryType,
  WarrOpCategoriesType,
  warrclaimconfigType,
  InitialWarrClaimCfg
}  from '../../context/WarrOpsCodesContext'  // ,WarrOpCategoryType,WarrOpCategoriesType

import UploadImages from '../components/UploadImages'

import { returnBasenameUrl } from '../../utils';

import dayjs, { Dayjs } from 'dayjs'
import * as isLeapYear from 'dayjs/plugin/isLeapYear'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';

import ImageMapper from 'react-img-mapper';
import type { MapArea, RefProperties } from 'react-img-mapper';
import {PrFissesProvider, PrFissesContext, usePrFissescontext} from '../../context/PrFissesContext'
import {PrProduct,PrCartProps,PrCartBrandProps,PrBrandType,PrBrandsIf,PrCartIf} from '../../components/Products'

// * import from WarrantyClaimContext
// interface PrData {
//   id: number;
//   prcode: string;
//   prname: string;
//   qty: number;
// }
import {WarrClaimContext,PrData,laborexample,IWarrClaimContextState,initialWarrClaimContextState} from '../../context/WarrantyClaimContext'
import NumberField from './NumberField';

// @ts-expect-error
dayjs.extend(isLeapYear) // use plugin
dayjs.locale('el')


const KLM_NUMERIC_ONLY = /^[0-9]+$/;

const OkMark = styled('span')`
  margin-left: 8px;
  margin-top: 10px;
  color: rgb(125 200 0 / 1);
`;

// const getWarrOps = (warropsdata:WarrOpsCodesResponseType) => {
//   if(warropsdata)
//       if(warropsdata.fetched==true && warropsdata.success==true && warropsdata.data
//           && warropsdata.data.warrops
//           && warropsdata.data.warrops.length>0  ) {
//           return warropsdata.data.warrops;
//       }
//       else return  null
//   else return  null
// }

const steps = [
  'Πλαίσιο', 
  'Κωδικοί βλάβης...', 
  'Ανταλλακτικά-Εργασίες', 
  'Στοιχεία Πελάτη',
  'Αποστολή', 
  'Επισύναψη φωτό'
];
const stepsmessage = [
  'Εισαγωγή πλαισίου της μοτοσυκλέτας', 
  'Συμπλήρωση κωδικών και γενικών στοιχείων', 
  'Προσθήκη Ανταλλακτικών-Εργασιών', 
  'Συμπλήρωση Στοιχείων Πελάτη',
  'Αποστολή', 
  'Επισύναψη φωτό'
];

function getSessionWarrClaimData()
{
  const storedState = sessionStorage.getItem(`${process.env.REACT_APP_WARRCLMSESSKEY}`);
  if (storedState) {
    console.log("==* function getSessionWarrClaimData returning storedState=",storedState)
    return(JSON.parse(storedState)) as IWarrClaimContextState;
  }
  else {
    console.log("==* function getSessionWarrClaimData returning initialWarrClaimContextState=",initialWarrClaimContextState)
    return {...initialWarrClaimContextState,  warrdate: dayjs(new Date()).toJSON() }
  }
}
// * not used ?
// const warrcodegroupexample ={
//   "groupid": "poorappearance",
//   "groupname": "Poor appearance",
// }

// * imported from WarrantyClaimContext
// const laborexample =  {
//   id: 2,
//   labcode: "0010",
//   labenname: "Engine R&R ",
//   labseccode: "0010",
//   labelname: "Κινητήρας R&R ",
//   labqty: 1.0,
//   labnotes: "my notes"
// };

export default function WarrantyClaim() {

  if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log("=JS WarrantyClaim=, starts ...")
    let auth = useAuth();
    let warrOpsCodesContext = useWarrOpsCodesContext();

    const fisses = usePrFissescontext().prfissescontextdata
    if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log('PrFisses fisses=',fisses)

    // imports {WarrClaimContext,PrData,laborexample,IWarrClaimContextState,initialWarrClaimContextState} 
    // const { warrclaimState, setWarrclaimContext, resetWarrclaimContext  } = React.useContext(WarrClaimContext)!;
    const { warrClaimState, setWarrclaimContext, resetWarrclaimContext,getWarrclaimContext } = React.useContext(WarrClaimContext)!;

    const [warrclaimState, setWClState] = React.useState(
      getSessionWarrClaimData()
    )
    // - {...initialWarrClaimContextState,  warrdate: dayjs(new Date()) }

    // * unused * const [warrstep, Setwarrstep] = React.useState('vindata')

    // * all the following variables are moved inside warrclaimstate and will be removed from here
    // const [activeStep, setActiveStep] = React.useState(0);
    // form state variables ...
    // const [vin, setVin] = React.useState('')
    // const [warrdate, setWarrdate] = React.useState<dayjs.Dayjs|null>(dayjs(new Date()))
    // const [faultCode, setFaultCode] = React.useState('')  // ανταλλακτικό
    // const [faultypegroup, setFaulttypegroup] = React.useState({code:'', name:''}) // faulttypegroup
    // const [causeCode, setCauseCode] = React.useState({code:'', name:''})  // faulttype
    // const [troublegroup, setTroublegroup] = React.useState({code:'', name:''}) 
    // const [trouble, setTrouble] = React.useState({code:'', name:''})  
    // const [reasongroup, setReasongroup] = React.useState({code:'', name:''}) 
    // const [reason, setReason] = React.useState({code:'', name:''})  // faulttype
    // const [incidentdescr, setIncidentdescr] = React.useState('')
    // const [prrows, setPrrows] = React.useState<PrData[]>([])
    // const [labrows, setLabrows] = React.useState<(typeof laborexample)[]>([])
    //const [warrclaimdocid, setWarrclaimdocid ] = React.useState(0); // React.useState(63047)
    // const [warrclaimdoccode, setWarrclaimdoccode ] = React.useState(""); // React.useState("GRWRC00005")
    // * end replacement

    const [warrOpers, SetWarrOpers]=React.useState<WarrOpType[]|null>(null)
    // const [warrOpsCategs, SetwarrOpsCategs]=React.useState<WarrOpCategoriesType|null>(null)
    const [faultypes, setFaultypes]=React.useState<OpCodeCategType[]|null>(null)
    // const [faultypesgroups, setfaultypesgroups]=React.useState<typeof warrcodegroupexample[]|null>(null)
    const [troubles, setTroubles]=React.useState<OpCodeCategType[]|null>(null)
    // const [troublesgroups, setTroublesgroups]=React.useState<typeof warrcodegroupexample[]|null>(null)
    const [reasons, setReasons]=React.useState<OpCodeCategType[]|null>(null)
    // const [reasonsgroups, setReasonsgroups]=React.useState<typeof warrcodegroupexample[]|null>(null)
    // const [warrOpers, SetWarrOpers]=React.useState(warrOpsCodesContext.getWarrOps)
    // const [warrOpsCategs, SetwarrOpsCategs]=React.useState(warrOpsCodesContext.getWarrOpsCategs)
    // const [faultypes, setFaultypes]=React.useState(warrOpsCodesContext.getfaultypes)
    // const [faultypesgroups, setfaultypesgroups]=React.useState(warrOpsCodesContext.getFaulttypesGroups)
    // const [troubles, setTroubles]=React.useState(warrOpsCodesContext.gettroubles)
    // const [troublesgroups, setTroublesgroups]=React.useState(warrOpsCodesContext.getTroublesGroups)
    // const [reasons, setReasons]=React.useState(warrOpsCodesContext.getreasons)
    // const [reasonsgroups, setReasonsgroups]=React.useState(warrOpsCodesContext.getReasonsGroups)
    const [warrclaimconfig, Setwarrclaimconfig]=React.useState<warrclaimconfigType|null>(InitialWarrClaimCfg)
    
    const [asuinfo, Setasuinfo]=React.useState({
      WEBSERVICE: 0,
      bu: 0,
      buname: "",
      trdr: 0,
      trdbame: "",
      trdbranch: 0,
      trdbrnname: "",
      trdafm: "",
      trdemail: "",
      whs: "",
      accesslevel: 0
    })

   
    const [opercateg, setOpercateg]=React.useState('')
    const [operation, setOperation]=React.useState('')

    const [addprcode,setAddprcode]= React.useState('')
    const [addprqty,setAddprqty]= React.useState('1')

    const [addlabcode,setAddlabcode]= React.useState('')
    const [addlabqty,setAddlabqty]= React.useState('1.0')

    const [isPartsLoading, setIsPartsLoading]= React.useState(true)
    const [isLabLoading, setIsLabLoading]= React.useState(true)
    const [isposting, setIsposting]=React.useState(false)

    const [vininfo, Setvininfo]=React.useState({
      vehid:0,
      vin:"",
      vehname:"",
      vehname2:"",
      brandid:0,
      modelid:0,
      brandcode:"",
      modelcode:"",
      brandname:"",
      modelname:""
    })
    
    const Demo = styled('div')(({ theme }) => ({
      backgroundColor: (theme.vars || theme).palette.background.paper,
    }));

    function setWarrclaimstate(source:Object){
      console.log("==* function setWarrclaimstate called with source=",source)
      const copywcst = Object.assign({}, warrclaimState);
      const returnedTarget = Object.assign(copywcst, source);
      console.log("==* function setWarrclaimstate called, new warrclaimState will be=",returnedTarget)
      // state variable
      setWClState(returnedTarget)
      // store to session storage
      setWarrclaimContext(returnedTarget)
    }

    let codesLoaded = warrOpers!==null && warrOpers.length>0 && faultypes!==null && faultypes.length>0 &&
    troubles!==null && troubles.length>0 && reasons!==null && reasons.length>0
    if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log("=JS WarrantyClaim=, codesLoaded=",codesLoaded,"warrOpers length=",warrOpers?.length)

    React.useEffect(()=>{
      console.log('=JS WarrantyClaim=, useeffect[] called...')
      auth.userData.userinfo?.bus?.forEach( (obu:any) =>{
        console.log('=JS WarrantyClaim=, WarrantyClaim useeffect[] obu=',obu)
        if(`${obu.bu}`===process.env.REACT_APP_AFTERSBU) {
          Setasuinfo({
            WEBSERVICE: obu.WEBSERVICE,
            bu:  obu.bu,
            buname:  obu.buname,
            trdr:  obu.trdr,
            trdbame:  obu.trdbame,
            trdbranch: obu.trdbranch,
            trdbrnname:  obu.trdbrnname,
            trdafm:  obu.trdafm,
            trdemail:  obu.trdemail,
            whs:  obu.whs,
            accesslevel:  obu.accesslevel
          })         
        }
      })
      console.log("=JS WarrantyClaim=, WarrantyClaim useeffect[] loading warranty operarions and codes...")
      let warropscodescontextdata = warrOpsCodesContext.setWarropscodescontext();
    },[])
    
    React.useEffect(()=>{
      console.log("=JS WarrantyClaim=, WarrantyClaim useeffect[warrOpsCodesContext.warrOpsCodesContextdata.fetched,=",warrOpsCodesContext.warrOpsCodesContextdata.fetched,
      "warrOpsCodesContext.warrOpsCodesContextdata.success=",warrOpsCodesContext.warrOpsCodesContextdata.success,"] ...")
      if( warrOpsCodesContext.warrOpsCodesContextdata.success==true && warrOpsCodesContext.warrOpsCodesContextdata.fetched==true
        && warrOpsCodesContext.warrOpsCodesContextdata.data && codesLoaded === false )
      {
        console.log("=JS WarrantyClaim=, WarrantyClaim useeffect[success,fetched,codesLoaded]==true,true,false => update categories fault codes, ...")
        let loadingWarrantyoperations = false
        let loadingFaultTypes = false;
        let loadingTroubles = false;
        let loadingReasons = false;

        if( warrOpsCodesContext.warrOpsCodesContextdata.data.warrops && 
          warrOpsCodesContext.warrOpsCodesContextdata.data.warrops.length>0)
          {
            loadingWarrantyoperations=true
          }

          if( warrOpsCodesContext.warrOpsCodesContextdata.data.troubles && 
            warrOpsCodesContext.warrOpsCodesContextdata.data.troubles.length>0){
              loadingTroubles=true
          }

          if( warrOpsCodesContext.warrOpsCodesContextdata.data.reasons && 
            warrOpsCodesContext.warrOpsCodesContextdata.data.reasons.length>0){
              loadingReasons=true
          }
 
          if( warrOpsCodesContext.warrOpsCodesContextdata.data.faultypes && 
            warrOpsCodesContext.warrOpsCodesContextdata.data.faultypes.length>0){
              loadingFaultTypes=true
          }

          if(loadingWarrantyoperations && loadingFaultTypes && loadingReasons && loadingTroubles)
          {
            SetWarrOpers(warrOpsCodesContext.warrOpsCodesContextdata.data.warrops) 
            // SetwarrOpsCategs(warrOpsCodesContext.getWarrOpsCategs())
            setFaultypes(warrOpsCodesContext.warrOpsCodesContextdata.data.faultypes)
            // setfaultypesgroups(warrOpsCodesContext.getFaulttypesGroups)
            setReasons(warrOpsCodesContext.warrOpsCodesContextdata.data.reasons)
            // setReasonsgroups(warrOpsCodesContext.getReasonsGroups)
            setTroubles(warrOpsCodesContext.warrOpsCodesContextdata.data.troubles)
            // setTroublesgroups(warrOpsCodesContext.getTroublesGroups)
          }
          else {
            SetWarrOpers(null) 
            // SetwarrOpsCategs(null)
            setTroubles(null)
            // setTroublesgroups(null)
            setReasons(null)
            // setReasonsgroups(null)
            setFaultypes(null)
            // setfaultypesgroups(null)
          }
          if( warrOpsCodesContext.warrOpsCodesContextdata.data.warrclaimconfig)
            Setwarrclaimconfig(warrOpsCodesContext.warrOpsCodesContextdata.data.warrclaimconfig)
      }
    },[warrOpsCodesContext.warrOpsCodesContextdata.fetched, warrOpsCodesContext.warrOpsCodesContextdata.success, codesLoaded])

    const handleNext = () => {
        // let newSkipped = skipped;
        // if (isStepSkipped(activeStep)) {
        //   newSkipped = new Set(newSkipped.values());
        //   newSkipped.delete(activeStep);
        // }
        // malaguti: VB4ET9009NY000207

        /* const steps = [
          'Πλαίσιο',                  0
          'Κωδικοί βλάβης...',       1 
          'Ανταλλακτικά-Εργασίες',    2
          'Στοιχεία Πελάτη',          3  
          'Αποστολή',                 4
          'Επισύναψη φωτό'           5 
        ]; */
      let canNext=false;

      /* in adding VIN */
      if(warrclaimState.activeStep==0){
        if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log('handleNext from 0,  asuinfo',asuinfo)
        if(warrclaimState.vin.length<17 || warrclaimState.vin.trim()=="") {alert('vin empty or wrong');return;}
        // ????????? if(!isvinok) {alert('!isvinok');return;}
        if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}

        let usercode = auth.userData.username
        let token = auth.userData.token
        let postdata = {
          service: "getvinforwarrinfo", 
          usercode: usercode,
          vin: warrclaimState.vin,
          clientid: token,
          trdr: asuinfo.trdr,
          trdbranch:asuinfo.trdbranch,
          accesslevel: asuinfo.accesslevel,
          userid: auth.userData.userid,
          webservice: asuinfo.WEBSERVICE, 
          bu: asuinfo.bu
        }
        let body = JSON.stringify(postdata)
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
          body: body , cache: "no-store"
        })
        .then((response) =>  {
          if (!response.ok) return {} 
          else return response.json()
        })
        .then((data:any) => {
          // console.log(" PrAvOrd fetch Pr AV then ... data=",data)
          const isSuccessVehInfoResponse = (data: any): data is IVehWarrInfoResponse =>
            typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
          if (isSuccessVehInfoResponse(data) && data.success!==true)
          {
            alert('Η εύρεση πλαισίου απέτυχε.')
          }
          else {
            // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
            if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
      
              if( data.totalcount<=0) {
                alert('Η εύρεση πλαισίου απέτυχε (query return empty, non existing vin')
              }
              else {
                if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log('vin info=', data.data[0])
                Setvininfo({
                  vehid: data.data[0].vehid,
                  vin: data.data[0].vin,
                  vehname: data.data[0].vehname,
                  vehname2: data.data[0].vehname2,
                  brandid: data.data[0].brandid,
                  modelid: data.data[0].modelid,
                  brandcode: data.data[0].brandcode,
                  modelcode: data.data[0].modelcode,
                  brandname: data.data[0].brandname,
                  modelname: data.data[0].modelname
                })


                /* * { vehid: 56727, 
                vin: "VB4ET9009NY000207", 
                vehname: "MALAGUTI Spectre GP 125-Corsa Black/Red", 
                vehname2: "ET9 VB4ET9009NY000207 Spectre GP 125", 
                brandid: 3, 
                modelid: 60, 
                brandcode: "MALAGUTI",
                modelcode: "ET9", 
                brandname: "MALAGUTI", 
                modelname: "MALAGUTI" } 
                { fetched: true, success: true, error: "", modelfisses: (1) […] }
                error: ""
​                fetched: true
                modelfisses: Array [ ​
                  0: Array(5) [   
                    0: "MALAGUTI"           ​​​
                    1: "LAVA120(517D,CBS)""
                    2: "lava120.jpg"
                    3: "modelfissess-malaguti-lava120.txt"
                    4: "sparepartsbookwithpriceofLAVA120.txt"
                  ]
                ]
                success: true  
                * */

                /// console.log("=JS WarrantyClaim=, handleNext, fetched data vin Success rows Array set")
                // setActiveStep((prevActiveStep) => prevActiveStep + 1);

                // setWarrclaimstate( (prevwarrclaimstate) =>({
                //       ...prevwarrclaimstate, activeStep: prevwarrclaimstate.activeStep+1}) )

                if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log("=JS WarrantyClaim=, handleNext from 0, setting next step")
                setWarrclaimstate({activeStep: warrclaimState.activeStep+1})

              }
            }
            else {
              alert('Η εύρεση πλαισίου δεν είχε αποτέλεσμα. Ο κωδικός δεν υπάρχει (query return empty, non existing vin')
            }
          }
        }) 
        return
      }
      /* in adding cause code, fault code, etc .... */
      if(warrclaimState.activeStep==1){
        console.log('"=JS WarrantyClaim=, handleNext, from  1,  asuinfo',asuinfo)
        var datedayjs = dayjs(warrclaimState.warrdate)
        if(!dayjs.isDayjs(datedayjs)){alert('Εισάγετε σωστή ημερομηνία εγγύησης');return;}
        // if(!dayjs.isDayjs(warrclaimState.warrdate)){alert('Εισάγετε σωστή ημερομηνία εγγύησης');return;}
        if(warrclaimState.faultCode.length<=0 || warrclaimState.faultCode.trim()=="") {alert('Εισάγετε τύπο προβλήματος (ανταλλακτικό)');return;}
        if(warrclaimState.causeCode===undefined || warrclaimState.causeCode===null || warrclaimState.causeCode.code.length<=0 || warrclaimState.causeCode.code.trim()=="") {alert('Εισάγετε τύπο βλάβης');return;}
        if(warrclaimState.trouble===undefined || warrclaimState.trouble===null || warrclaimState.trouble.code.length<=0 || warrclaimState.trouble.code.trim()=="") {alert('Εισάγετε Trouble code');return;}
        if(warrclaimState.reason===undefined || warrclaimState.reason===null || warrclaimState.reason.code.length<=0 || warrclaimState.reason.code.trim()=="") {alert('Εισάγετε Reason');return;}
        if(warrclaimState.incidentdescr.length<=0 || warrclaimState.incidentdescr.trim()=="") {alert('Εισάγετε περιγραφή προβλήματος');return;}
        //if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('!bad bu trdr trdbranch');return;}
        let usercode = auth.userData.username
        let token = auth.userData.token
        let postdata = {
          service: "getpravinfo", 
          usercode: usercode,
          prcode: warrclaimState.faultCode,
          prqty: 1,
          prbrand: "9999",
          markoption: 9999,      
          brandavfilter: 0,
          notbrandavfilter: '200,1000',
          clientid: token
        }
        let body = JSON.stringify(postdata)
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
          body: body , cache: "no-store"
        })
        .then((response) =>  {
          if (!response.ok) return {} 
          else return response.json()
        })
        .then((data:any) => {
          // console.log(" PrAvOrd fetch Pr AV then ... data=",data)
          const isSuccessPrAvInfoResponse = (data: any): data is IPrAvResponse =>
          typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
          if (isSuccessPrAvInfoResponse(data) && data.success!==true)
          {
            alert(' Ο έλεγχος τύπου βλάβης (ανταλλακτικό) απέτυχε. Προσπαθήστε ξανά σε λίγο (query failed, try again later)')
          }
          else {
            // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
            if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
              if( data.totalcount<=0) {
                alert('Ο έλεγχος τύπου βλάβης (ανταλλακτικό) δεν επέστρεψε αποτέλεσμα. Ο κωδικός δεν υπάρχει (query return empty, non existing pr code')
              }
              else {
                // console.log(" fetched data Success rows Array set")
                // setActiveStep((prevActiveStep) => prevActiveStep + 1);
                setWarrclaimstate({activeStep: warrclaimState.activeStep+1})
              }
            }
            else {
              alert('Ο έλεγχος τύπου βλάβης (ανταλλακτικό) δεν είχε αποτέλεσμα. Ο κωδικός δεν υπάρχει (query return empty, non existing pr code')
            }
          }
        }) 
        return
      }

      /* adding parts and labours */
      if(warrclaimState.activeStep==2){
        // console.log('"=JS WarrantyClaim=, handleNext, from  2,  asuinfo',asuinfo, "loading cfgcl")
        if(warrclaimState.prrows.length<=0 || warrclaimState.labrows.length<=0) return;
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setWarrclaimstate({activeStep: warrclaimState.activeStep+1})
      }

      /* in customer data */
      if(warrclaimState.activeStep==3){
        setWarrclaimstate({activeStep: warrclaimState.activeStep+1})
      }

      /* in saving */
      if(warrclaimState.activeStep==4){
        // console.log('"=JS WarrantyClaim=, handleNext, from  3,  asuinfo',asuinfo, "warrclaimdocid",warrclaimdocid)
        if(warrclaimState.warrclaimdocid<=0) {console.log(`step==4 ${warrclaimState.activeStep} and warrclaimdocid<=0 ${warrclaimState.warrclaimdocid} return`); return; };
        // setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setWarrclaimstate({activeStep: warrclaimState.activeStep+1})
      }

      /* in uploading photos */
      if(warrclaimState.activeStep === 5){
        handleReset()
      }

      // setSkipped(newSkipped);
    };
    
    const handleBack = () => {
      if(warrclaimState.activeStep>=4 && warrclaimState.warrclaimdocid>0) {console.log(`step>=4 ${warrclaimState.activeStep} and warrclaimdocid>0 ${warrclaimState.warrclaimdocid} return`); return; }
      else {
        // setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setWarrclaimstate({activeStep: warrclaimState.activeStep-1})
      }
    };

    const handleReset = () => {

      // * replaced by warrclaimstate
      // setVin('')
      // setWarrdate(dayjs(new Date()))
      // setFaultCode('')  // ανταλλακτικό
      // setFaulttypegroup({code:'', name:''}) // faulttypegroup
      // setCauseCode({code:'', name:''})  // faulttype
      // setTroublegroup({code:'', name:''}) 
      // setTrouble({code:'', name:''})  
      // setReasongroup({code:'', name:''}) 
      // setReason({code:'', name:''})  // faulttype
      // setIncidentdescr('')
      // const [selwarrOpers, setSelWarrOpers]=React.useState<WarrOpType[]|null>(null)
      // setPrrows([])
      // setLabrows([])
      // setWarrclaimdocid(63047)
      // setWarrclaimdoccode("GRWRC00005")
      //setActiveStep(0);
      // *

      setOpercateg('')
      setOperation('')
      setAddprcode('')
      setAddprqty('1')
      setAddlabcode('')
      setAddlabqty('1.0')
      setIsPartsLoading(true)
      setIsLabLoading(true)
      setIsposting(false)
  
      Setvininfo({
        vehid:0,
        vin:"",
        vehname:"",
        vehname2:"",
        brandid:0,
        modelid:0,
        brandcode:"",
        modelcode:"",
        brandname:"",
        modelname:""
      })

      setWarrclaimstate({...initialWarrClaimContextState, warrdate: dayjs(new Date()).toJSON() })
      resetWarrclaimContext()
    };

    function vinChanged(pvin:string){
      // called for every typed character !!!!!!
      // console.log('vinChanged with', pvin)
      // setVin(pvin)
      // warrclaimstate, 
      // setWarrclaimstate( (prevwarrclaimstate) =>({
      //   ...prevwarrclaimstate, vin: pvin}) )
        setWarrclaimstate({vin: pvin})
    }

    const hChangeSelFaultypegroup = (event: React.ChangeEvent<HTMLSelectElement> ) => {
      if(event.target.value.trim()==""){
        // setCauseCode({code:'', name:''});
        // setFaulttypegroup('');
        // setFaulttypegroup({code:'',name:''});
        
        // setWarrclaimstate( (prevwarrclaimstate) =>({
        // ...prevwarrclaimstate, causeCode:{code:'', name:''},  faultypegroup: {code:'', name:''}}) )
        setWarrclaimstate({ causeCode:{code:'', name:''},  faultypegroup: {code:'', name:''} })
      }
      else {
        // setCauseCode({code:'', name:''})
        // setFaulttypegroup(event.target.value.trim())
        // setFaulttypegroup({code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text.trim()})

        // setWarrclaimstate( (prevwarrclaimstate) =>({
        // ...prevwarrclaimstate, causeCode:{code:'', name:''},  faultypegroup: {
        //   code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text.trim() }}) )
        setWarrclaimstate({ 
          causeCode:{code:'', name:''},  
          faultypegroup: {code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text.trim()} 
        })
      }
    }

    const hChangeSelTroublegroup = (event: React.ChangeEvent<HTMLSelectElement> ) => {
      if(event.target.value.trim()==""){
        // setTrouble({code:'', name:''});
        // setTroublegroup({code:'', name:''});

        // setWarrclaimstate( (prevwarrclaimstate) =>({
        // ...prevwarrclaimstate, trouble:{code:'', name:''},  troublegroup: {code:'', name:''}}) )
        setWarrclaimstate({ 
          trouble:{code:'', name:''}, 
          troublegroup: {code:'', name:''}
        })
      }
      else {
        // setTrouble({code:'', name:''})
        // setTroublegroup({code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text})

        // setWarrclaimstate( (prevwarrclaimstate) =>({
        // ...prevwarrclaimstate, trouble:{code:'', name:''},  troublegroup: {
        //   code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text.trim() }
        // }) )
        setWarrclaimstate({ 
          trouble:{code:'', name:''},  
          troublegroup: { code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text.trim() }
        })
      }
    }

    const hChangeSelReasongroup= (event: React.ChangeEvent<HTMLSelectElement> ) => {
      if(event.target.value.trim()==""){
        // setReason({code:'', name:''});
        // setReasongroup({code:'', name:''});

        // setWarrclaimstate( (prevwarrclaimstate) =>({
        // ...prevwarrclaimstate, reason:{code:'', name:''},  reasongroup: {code:'', name:''}}) )
        setWarrclaimstate({ reason:{code:'', name:''},  reasongroup: {code:'', name:''}  })
      }
      else {
        // setReason({code:'', name:''})
        // setReasongroup({code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text})

        // setWarrclaimstate( (prevwarrclaimstate) =>({
        // ...prevwarrclaimstate, reason:{code:'', name:''},  reasongroup: {
        //   code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text.trim() }}) )
        setWarrclaimstate({ 
          reason:{code:'', name:''}, 
          reasongroup: { code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text.trim() }
        })
      }
    }

    function setAddprQty(sqty:string){
      if(sqty.length<=0) return;
      if(!parseFloat(sqty)) return;
      setAddprqty(sqty)
    }

    function addPrTotable(){
      if(!(addprcode.length>0 && addprqty.length>0 && parseFloat(addprqty))) {
        return;
      }
      setIsPartsLoading(true)
      let usercode = auth.userData.username
      let token = auth.userData.token
      let postdata = {
        service: "getpravinfo", 
        usercode: usercode,
        prcode: addprcode,
        prqty: 1,
        prbrand: "9999",
        markoption: 9999,      
        brandavfilter: 0,
        notbrandavfilter: '200,1000',
        clientid: token
      }
      let body = JSON.stringify(postdata)
      const ms = Date.now();
      let basename=returnBasenameUrl()
      let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
        body: body , cache: "no-store"
      })
      .then((response) =>  {
        if (!response.ok) return {} 
        else return response.json()
      })
      .then((data:any) => {
        // console.log(" PrAvOrd fetch Pr AV then ... data=",data)
        const isSuccessPrAvInfoResponse = (data: any): data is IPrAvResponse =>
        typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
        if (isSuccessPrAvInfoResponse(data) && data.success!==true)
        {
          alert(' Ο έλεγχος του ανταλλακτικού απέτυχε. Προσπαθήστε ξανά σε λίγο (query failed, try again later)')
        }
        else {
          // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
          if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
            if( data.totalcount<=0) {
              alert('Ο έλεγχος του ανταλλακτικού δεν επέστρεψε αποτέλεσμα. Ο κωδικός δεν υπάρχει (query return empty, non existing pr code')
            }
            else {
              // console.log(" fetched data Success rows Array set")
              var prrow = {
                id: data.data.id,
                prcode: data.data.code,
                prname: data.data.name,
                qty: parseFloat(addprqty)
              }

              // var found=false;
              // var result = warrclaimstate.prrows.map(el => { 
              //   if(el.id == data.data.id){
              //     el.qty = parseFloat(addprqty);
              //     found=true;
              //   } 
              // });
              // if(!found){
              //   setPrrows([...prrows,prrow])
              // }
              
              var found=false;
              var result2 = warrclaimState.prrows.map(el => { 
                if(el.id == data.data.id){
                  el.qty = parseFloat(addprqty);
                  found=true;
                } 
              });
              if(!found){
                // setWarrclaimstate( (prevwarrclaimstate) =>({
                //   ...prevwarrclaimstate,
                //   prrows: [...prevwarrclaimstate.prrows,prrow]
                // }))
                setWarrclaimstate({ prrows: [...warrclaimState.prrows,prrow] })
              }

            }
          }
          else {
            alert('Ο έλεγχος  του ανταλλακτικού δεν είχε αποτέλεσμα. Ο κωδικός δεν υπάρχει (query return empty, non existing pr code')
          }
        }
      }) 
      .finally(() => {
        setAddprQty('1')
        setAddprcode("")
        setIsPartsLoading(false) 
      })
    }

    function deleteRowsFromPrTable( rowslist:GridRowId[]){
      // console.log('deleteRowsFromPrTable called with list',rowslist)
      let rows = [...warrclaimState.prrows]
      for(let i=0;i<rowslist.length;i++){
        rows = rows.filter((row) => row.id !== rowslist[i]);
      }
      // setPrrows(rows);
      // setWarrclaimstate( (prevwarrclaimstate) =>({
      //   ...prevwarrclaimstate, prrows: rows }))
      setWarrclaimstate({ prrows: rows })
    }

    const hChangeSelOpCateg = (event: React.ChangeEvent<HTMLSelectElement> ) => { // SelectChangeEvent
      if(event.target.value.trim()==""){
        setOpercateg('');
        setOpercateg('')
      }
      else {
        setOpercateg('');
        setOpercateg(event.target.value.trim())
      }
    }

    const hChangeSelOperation = (event: React.ChangeEvent<HTMLSelectElement> ) => { // SelectChangeEvent
      if(event.target.value.trim()==""){
        setOperation('');
      }
      else {
        setOperation(event.target.value);
      }
    }

    function hUpdatedLabrRow(updatedrow: (typeof laborexample)){
      if (warrclaimState.labrows.length === 0) {
        return;
      }
      if(!updatedrow.labqty || updatedrow.labqty<=0)
      {
        alert('Λάθος ποσότητα ωρών στην εργασία')
        return
      }

      // setLabrows((prevRows) => {
      //   return prevRows.map((row, index) =>
      //     row.id === updatedrow.id ? { ...row, labqty: updatedrow.labqty, labnotes: updatedrow.labnotes } : row,
      //   );
      // });

      // setWarrclaimstate( (prevwarrclaimstate) =>({
      //   ...prevwarrclaimstate, labrows: prevwarrclaimstate.labrows.map((row, index) =>
      //     row.id === updatedrow.id ? { ...row, labqty: updatedrow.labqty, labnotes: updatedrow.labnotes } : row,
      //   )
      // }));
      setWarrclaimstate({ 
          labrows: warrclaimState.labrows.map((row, index) =>
          row.id === updatedrow.id ? { ...row, labqty: updatedrow.labqty, labnotes: updatedrow.labnotes } : row )
        })
    } 
    
    function deleteRowsFromLabrTable(rowslist:GridRowId[]){
      // console.log('deleteRowsFromLabrTable called with list',rowslist)
      let rows = [...warrclaimState.labrows]
      for(let i=0;i<rowslist.length;i++){
        rows = rows.filter((row) => row.id !== rowslist[i]);
      }
      // setLabrows(rows);
      // setWarrclaimstate( (prevwarrclaimstate) =>({
      //   ...prevwarrclaimstate, labrows: rows }))
      setWarrclaimstate({labrows: rows})
    }

    function addLabrTotable(){
      // console.log('Adding labor ',operation)
      if(operation.length<=0) return;
      // [2, "0010", "Engine R&R ", "0010", "Κινητήρας R&R " ],
      let operdata = warrOpers?.find( (item) => item[1]==operation)
      // console.log('seeking labor ',operation, 'operdata',operdata)
      if(operdata && operdata.length>0){
        // console.log('found operdata',operdata)
        let labor:(typeof laborexample) = {
          id: parseInt(`${operdata[0]}`),
          labcode: `${operdata[1]}`,
          labenname: `${operdata[2]}`,
          labseccode: `${operdata[3]}`,
          labelname: `${operdata[4]}`,
          labqty: 0,
          labnotes:''
        }

        // console.log('checking labor ',labor)
        // var found=false;
        // var result = labrows.map(el => { 
        //   if(el.id == labor.id){
        //     found=true;
        //   } 
        // });
        // if(!found){
        //   // console.log('adding to labrows',labrows,' labor ',labor)
        //   setLabrows((previousLabrows)=>[...previousLabrows,labor])
        // }

        var found=false;
        var result2 =  warrclaimState.labrows.map(el => { 
          if(el.id == labor.id){
            found=true;
          } 
        });
        if(!found){
          // console.log('adding to labrows',labrows,' labor ',labor)
          //  setWarrclaimstate( (prevwarrclaimstate) =>({
          //   ...prevwarrclaimstate,
          //   labrows: [...prevwarrclaimstate.labrows,labor]
          //  }))
          setWarrclaimstate({labrows: [...warrclaimState.labrows,labor]})
        }

        setOpercateg('')
        setOperation('')
      }
    }

    function postWarrClaim(){
      if(warrclaimState.warrclaimdocid>0) return
      
      if(warrclaimState.vin.length<17 || warrclaimState.vin.trim()=="") {alert('vin empty or wrong');return;}
      if(warrclaimState.faultCode.length<=0 || warrclaimState.faultCode.trim()=="") {alert('Εισάγετε τύπο προβλήματος');return;}

      var datedayjs = dayjs(warrclaimState.warrdate)
      if(!dayjs.isDayjs(datedayjs)){alert('Εισάγετε σωστή ημερομηνία εγγύησης');return;}
      // if(!dayjs.isDayjs(warrclaimState.warrdate)){alert('Εισάγετε σωστή ημερομηνία εγγύησης');return;}

      // if(causeCode.length<=0 || causeCode.trim()=="") {alert('Εισάγετε τύπο βλάβης');return;}
      // if(trouble.length<=0 || trouble.trim()=="") {alert('Εισάγετε Trouble code');return;}
      // if(reason.length<=0 || reason.trim()=="") {alert('Εισάγετε Reason');return;}
      // if(incidentdescr.length<=0 || incidentdescr.trim()=="") {alert('Εισάγετε περιγραφή προβλήματος');return;}
      // if(prrows.length<=0){alert('Εισάγετε ανταλλακτικά εγγύησης');return;}
      if(warrclaimState.labrows.length<=0){alert('Εισάγετε εργασίες εγγύησης');return;}
      if(`${asuinfo.bu}`!==process.env.REACT_APP_AFTERSBU || asuinfo.trdr<=0 ) {alert('Bad user information');return;}
      let aprs:Object[]=[]
      let albrs:Object[]=[]
      warrclaimState.prrows.forEach( (pr)=>{
        aprs.push({
          prcode: pr.prcode,
          prqty: pr.qty
        })
      })
      warrclaimState.labrows.forEach( (lbr)=>{
        albrs.push({
          lbrcode: lbr.labcode,
          lbrqty: lbr.labqty,
          lbrenname: lbr.labenname,
          lbrelname: lbr.labelname,
          lbrnotes: lbr.labnotes
        })
      })     
      var custname =(warrclaimState.custname.trim().length>0) ? warrclaimState.custname.trim() : "";
      var custaddr =(warrclaimState.custaddr.trim().length>0) ? warrclaimState.custaddr.trim() : "";
      var custzip =(warrclaimState.custzip.trim().length>0) ? warrclaimState.custzip.trim() : "";
      var custcity =(warrclaimState.custcity.trim().length>0) ? warrclaimState.custcity.trim() : "";
      var custcountry =(warrclaimState.custcountry.trim().length>0) ? warrclaimState.custcountry.trim() : "";
      var custmobile =(warrclaimState.custmobile.trim().length>0) ? warrclaimState.custmobile.trim() : "";
      var custemail =(warrclaimState.custemail.trim().length>0) ? warrclaimState.custemail.trim() : "";
      var klm = (warrclaimState.klm>0) ? warrclaimState.klm : 0;
      setIsposting(true)
      try{
        let usercode = auth.userData.username
        let token = auth.userData.token
        let postdata = {
          service: "postwarrclaim", 
          usercode: usercode,
          clientid: token,
          trdr: asuinfo.trdr,
          trdbranch:asuinfo.trdbranch,
          accesslevel: asuinfo.accesslevel,
          userid: auth.userData.userid,
          webservice: asuinfo.WEBSERVICE, 
          bu: asuinfo.bu,
          warrclaimdocid: warrclaimState.warrclaimdocid,
          vin: warrclaimState.vin,
          claimdate: datedayjs.format("DD/MM/YYYY"), // warrclaimState.warrdate.format("DD/MM/YYYY"),
          faultCode: warrclaimState.faultCode,
          faultypegroup: warrclaimState.faultypegroup.code,
          faultypegroupnm: warrclaimState.faultypegroup.name,
          causeCode: warrclaimState.causeCode.code,
          causeCodenm: warrclaimState.causeCode.name,
          troublegroup: warrclaimState.troublegroup.code,
          troublegroupnm: warrclaimState.troublegroup.name,
          trouble: warrclaimState.trouble.code,
          troublenm: warrclaimState.trouble.name,
          reasongroup: warrclaimState.reasongroup.code,
          reasongroupnm: warrclaimState.reasongroup.name,
          reason: warrclaimState.reason.code,
          reasonnm: warrclaimState.reason.name,
          incidentdescr: `${warrclaimState.incidentdescr.trim()}`,
          lbrs: albrs,
          prs: aprs,
          custname: custname,
          custaddr: custaddr,
          custzip: custzip,
          custcity: custcity,
          custcountry: custcountry,
          custmobile: custmobile,
          custemail: custemail,
          klm: klm,
          sqlclaimdate: datedayjs.format("YYYY-MM-DD"), // warrclaimState.warrdate.format("DD/MM/YYYY")
        }
        let body = JSON.stringify(postdata)
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
          body: body , 
          cache: "no-store"
        })
        .then((response) =>  {
          if (!response.ok) return {} 
          else return response.json()
        })
        .then((data:any) => {
          console.log(" post claim then ... data=",data)
          const isSuccessPostWarrClaimResponse = (data: any): data is IPostWarrClaimResponse =>
          typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
          if (isSuccessPostWarrClaimResponse(data) && data.success!==true)
          {
            alert(' Η καταχώριση του δελτίου εγγύησης απέτυχε. Προσπαθήστε ξανά σε λίγο (query failed, try again later)')
          }
          else {
            // console.log("data.hasOwnProperty('totalcount')",data.hasOwnProperty('totalcount'),"typeof data.totalcount",typeof data.totalcount)
            if(data.hasOwnProperty('totalcount') && typeof data.totalcount === 'number' && typeof data.data === 'object'){
              if( data.totalcount<=0) {
                alert('Η καταχώριση του δελτίου εγγύησης δεν επέστρεψε αποτέλεσμα. Προσπαθήστε ξανά σε λίγο (query failed, try again later)')
              }
              else {
                // console.log(" fetched data Success rows Array set")
                // setWarrclaimdocid(data.data.claimdocid);
                // setWarrclaimdoccode(data.data.claimdoccode);

                // setWarrclaimstate( (prevwarrclaimstate) =>({
                //   ...prevwarrclaimstate,
                //   warrclaimdocid: data.data.claimdocid, warrclaimdoccode: data.data.claimdoccode
                // }))
                setWarrclaimstate({warrclaimdocid: data.data.claimdocid, warrclaimdoccode: data.data.claimdoccode})

              }
            }
            else {
              alert('Η καταχώριση του δελτίου εγγύησης δεν είχε αποτέλεσμα. Προσπαθήστε ξανά σε λίγο (query failed, try again later)')
            }
          }
        }) 
      }
      catch(e){
        alert('Η καταχώριση του δελτίου εγγύησης απέτυχε. (query failed, try again later)')
      }
      finally{
        setIsposting(false)
      }
    }

    let disablePost = warrclaimState.warrclaimdocid>0 || isposting===true

    if( process.env.REACT_APP_ENABLEDEBUGLOG=="1") console.log("=JS WarrantyClaim=, warrclaimstate=", warrclaimState)
    // console.log("=JS WarrantyClaim=, activeStep=activeStep", "warrclaimstate.activeStep=",warrclaimstate.activeStep)
    // console.log("=JS WarrantyClaim=, vin=",vin, "warrclaimstate.vin=",warrclaimstate.vin)
    // console.log("=JS WarrantyClaim=, labrows=",labrows, "warrclaimstate.labrows=",warrclaimstate.labrows)
    // console.log("=JS WarrantyClaim=, prrows=",prrows, "warrclaimstate.prrows=",warrclaimstate.prrows)
    // console.log("=JS WarrantyClaim=, warrdate dayjs object=",warrdate, " typeof", typeof(warrdate))
    // console.log("=JS WarrantyClaim=, warrdate dayjs format()=",warrdate?.format(), " typeof", typeof(warrdate?.format()))
    // console.log("=JS WarrantyClaim=, warrdate dayjs format(YYYY-MM-DD)=",warrdate?.format("YYYY-MM-DD"), " typeof", typeof(warrdate?.format("YYYY-MM-DD")))

    // console.log("=JS WarrantyClaim=, faultypegroup=",faultypegroup)
    // console.log("=JS WarrantyClaim=, causeCode=", causeCode)

    if(codesLoaded===false){
      return(<>loading operations and warranty codes ...</>)
    }
    else {

    return(    
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={warrclaimState.activeStep}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};
          //   if (isStepOptional(index)) {
          //     labelProps.optional = (
          //       <Typography variant="caption">Optional</Typography>
          //     );
          //   }
          //   if (isStepSkipped(index)) {
          //     stepProps.completed = false;
          //   }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {warrclaimState.activeStep === steps.length ? (
        <Alert variant="outlined" severity="info">
          <Typography sx={{ mt: 2, mb: 1 }}>
            All steps completed - you&apos;re finished
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        </Alert>
      ) : (
        
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 1, justifyContent: 'space-between' }}>

            <div >
            <Typography sx={{mr:2}}>Βήμα {warrclaimState.activeStep + 1} {stepsmessage[warrclaimState.activeStep]}</Typography>
            </div>

            <div>
            <Button onClick={handleReset}>
              Reset
            </Button>
            </div>

            <div>
            <Button
              color="inherit"
              disabled={warrclaimState.activeStep === 0}
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Back
            </Button>
            </div>
            {/* <Box sx={{ flex: '1 1 auto' }} > */}
            {/* {isStepOptional(warrclaimstate.activeStep) && (
              <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                Skip
              </Button>
            )} */}


            <div>
            <Button onClick={handleNext}>
              {warrclaimState.activeStep === steps.length - 1 ? 'Finish' : 'Next'}
            </Button>
            </div>

          </Box>

      )}

      {warrclaimState.activeStep === 0 && (
          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }} noValidate autoComplete="off" >
            <Paper >
            <TextField
              required
              id="vin-required"
              label="Πλαίσιο"
              value={warrclaimState.vin}
              variant="standard"
              onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                vinChanged(event.target.value); }}
            />
            </Paper>
          </Box>
      ) }

      {warrclaimState.activeStep === 1 && (
        <React.Fragment>

          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}  >
            <Paper elevation={1} sx={{m:2,p:2}}>
            <Typography variant="subtitle2" component="span"> Πλαίσιο: </Typography>
            <Typography variant="body1" component="span">{warrclaimState.vin} </Typography>
            <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
            </Paper>
          </Box>

           <Paper elevation={1} sx={{m:2,p:1}}>

          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, maxWidth: '100%' } }} noValidate autoComplete="off" >

            <Grid container spacing={2}>

            <Grid size={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateField label="ημερομηνία εγγύησης"  size="small"
              value={dayjs(warrclaimState.warrdate)}
              onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={ (newValue) =>  setWarrclaimstate({ warrdate: newValue?.toJSON() }) }
              format="DD/MM/YYYY"
            />
            </LocalizationProvider>
            </Grid>

            <Grid size={6}>
            <TextField  required id="fault-code"  label="τύπος προβλήματος (ανταλλακτικό)"
              value={warrclaimState.faultCode}
              variant="standard"
               size="small"
               fullWidth
               onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                //setFaultCode(event.target.value); 
                setWarrclaimstate({faultCode: event.target.value })
              }}
            />
            </Grid>

            </Grid>

          </Box>

          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1,  maxWidth: '100%' } }} noValidate autoComplete="off" >
          <Grid container spacing={2}>

          <Grid size={6}>          
            {faultypes && <FormControl sx={{ m: 1, minWidth: 300 }} fullWidth>
            <InputLabel id="sel-faulttypegroup-label">Ομάδες Τύπων Βλάβης</InputLabel>
            <NativeSelect variant="standard" size="small" fullWidth
            id="sel-faulttypegroup"
            inputProps={{
              name: 'faulttypegroup-inp',
              id: 'faulttypegroup-inp',
            }}
            value={warrclaimState.faultypegroup.code}
            onChange={hChangeSelFaultypegroup}
            >
              <option  value="" > </option>
              {faultypes?.map( (item, index:number) =>  { 
                let sval = `${item.groupid}`
                let stitle = `${item.groupname}`
                let stitle_el = `${item.groupname_el}`
                let idx =`${index}`
                // console.log('sval',sval,'idx',idx,'stitle',stitle)
                return <option  value={sval} key={idx} >{stitle_el}</option>
              }) }
            </NativeSelect>
            </FormControl> }  
            </Grid>

            <Grid size={6}>
            {faultypes && <FormControl sx={{ m: 1, minWidth: 300 }} fullWidth>
            <InputLabel id="sel-causecode-label">Τύπος Βλάβης</InputLabel>
            <NativeSelect variant="standard" size="small" fullWidth
            id="sel-causecode"
            inputProps={{
              name: 'causecode-inp',
              id: 'causecode-inp',
            }}
            value={warrclaimState.causeCode.code}
            onChange={ (event)=>
              // setCauseCode({code: event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text})
              setWarrclaimstate( {
                causeCode: {code: event.target.value.trim(), 
                name:event.target.options[event.target.selectedIndex].text} })            
              }
            >
              <option  value="" > </option>
              {faultypes?.find( (item) => item.groupid===warrclaimState.faultypegroup.code)?.items
              .map( (item, index:number) =>  { 
                let sval = `${item[0]}`
                let stitle = `${item[0]}-${item[1]}`
                let stitle_el = `${item[0]}-${item[2]}`
                let idx =`${index}`
                // console.log('sval',sval,'idx',idx,'stitle',stitle)
                return <option value={sval} key={idx} >{stitle_el}</option>
              }) }
            </NativeSelect>
            </FormControl> }
            </Grid>

            </Grid>
          </Box>
          
          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, minWidth: 300, maxWidth: '100%' } }} noValidate autoComplete="off" >
          <Grid container spacing={2}>

          <Grid size={6} > 

            {troubles && <FormControl sx={{ m: 1, minWidth: 300 }} fullWidth>
            <InputLabel id="sel-troublesgroup-label">Ομάδες Trouble Codes</InputLabel>
            <NativeSelect variant="standard" size="small"
            id="sel-troublesgroup"
            inputProps={{
              name: 'troublesgroup-inp',
              id: 'troublesgroup-inp',
            }}
            value={warrclaimState.troublegroup.code}
            onChange={hChangeSelTroublegroup}
            >
              <option  value="" > </option>
              {troubles?.map( (item, index:number) =>  { 
                let sval = `${item.groupid}`
                let stitle = `${item.groupname}`
                let stitle_el = `${item.groupname_el}`
                let idx =`${index}`
                // console.log('sval',sval,'idx',idx,'stitle',stitle)
                return <option  value={sval} key={idx} >{stitle_el}</option>
              }) }
            </NativeSelect>
            </FormControl> }  
            </Grid>

            <Grid size={6}> 
            {troubles && <FormControl sx={{ m: 1, minWidth: 300 }} fullWidth>
            <InputLabel id="sel-trouble-label">Trouble Code</InputLabel>
            <NativeSelect variant="standard" size="small"
            id="sel-trouble"
            inputProps={{
              name: 'trouble-inp',
              id: 'trouble-inp',
            }}
            value={warrclaimState.trouble.code}
            onChange={(event)=>
              // setTrouble({code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text})
              setWarrclaimstate( ({
                trouble: {code:event.target.value.trim(), 
                name:event.target.options[event.target.selectedIndex].text} }))            
            }
            >
              <option  value="" > </option>
              {troubles?.find( (item) => item.groupid===warrclaimState.troublegroup.code)?.items
              .map( (item, index:number) =>  { 
                let sval = `${item[0]}`
                let stitle = `${item[0]}-${item[1]}`
                let stitle_el = `${item[0]}-${item[2]}`
                let idx =`${index}`
                // console.log('sval',sval,'idx',idx,'stitle',stitle)
                return <option value={sval} key={idx} >{stitle_el}</option>
              }) }
            </NativeSelect>
            </FormControl> }
            </Grid>

            </Grid>
          </Box>

          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, minWidth: 300, maxWidth: '100%' } }} noValidate autoComplete="off" >
          <Grid container spacing={2}>

          <Grid size={6}> 

            {reasons && <FormControl sx={{ m: 1, minWidth: 300 }} fullWidth>
            <InputLabel id="sel-reasonsgroup-label">Ομάδες Reason Codes</InputLabel>
            <NativeSelect variant="standard" size="small"
            id="sel-reasonsgroup"
            inputProps={{
              name: 'reasonsgroup-inp',
              id: 'reasonsgroup-inp',
            }}
            value={warrclaimState.reasongroup.code}
            onChange={hChangeSelReasongroup}
            >
              <option  value="" > </option>
              {reasons?.map( (item, index:number) =>  { 
                let sval = `${item.groupid}`
                let stitle = `${item.groupname}`
                let stitle_el = `${item.groupname_el}`
                let idx =`${index}`
                // console.log('sval',sval,'idx',idx,'stitle',stitle)
                return <option  value={sval} key={idx} >{stitle_el}</option>
              }) }
            </NativeSelect>
            </FormControl> }  
            </Grid>

            <Grid size={6}> 
            {reasons && <FormControl sx={{ m: 1, minWidth: 300 }} fullWidth>
            <InputLabel id="sel-reason-label">Reason Code</InputLabel>
            <NativeSelect variant="standard"  size="small"
            id="sel-reason"
            inputProps={{
              name: 'reason-inp',
              id: 'reason-inp',
            }}
            value={warrclaimState.reason.code}
            onChange={(event)=>
              // setReason({code:event.target.value.trim(), name: event.target.options[event.target.selectedIndex].text})
              setWarrclaimstate({
                reason: {code:event.target.value.trim(), 
                name:event.target.options[event.target.selectedIndex].text} })            
            }
            >
              <option  value="" > </option>
              {reasons?.find( (item) => item.groupid===warrclaimState.reasongroup.code)?.items
              .map( (item, index:number) =>  { 
                let sval = `${item[0]}`
                let stitle = `${item[0]}-${item[1]}`
                let stitle_el = `${item[0]}-${item[2]}`
                let idx =`${index}`
                // console.log('sval',sval,'idx',idx,'stitle',stitle)
                return <option value={sval} key={idx} >{stitle_el}</option>
              }) }
            </NativeSelect>
            </FormControl> }
            </Grid>
            
            </Grid>
          </Box>

          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >

          <Grid container spacing={2}>

          <Grid size={4}> 

            <TextField
              required
              id="Klm-required"
              label="Klm"
              value={warrclaimState.klm}
              variant="standard"
              onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const value = event.target.value;
                if (value !== "" && !KLM_NUMERIC_ONLY.test(value)) {
                  return;
                }
                setWarrclaimstate({ klm: value })
               }}
            />

          </Grid>

          <Grid size={8}> 
          <div>
          <TextField fullWidth sx={{ m: 1 }} variant="standard"  size="small"
          id="incident-descr"
          label="Περιγραφή"
          multiline
          rows={4}
          value={warrclaimState.incidentdescr}
          onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            // setIncidentdescr(event.target.value); 
            setWarrclaimstate( { incidentdescr: event.target.value })         
          }}  
          />
          </div>
          </Grid>

          </Grid>

          </Box>

        </Paper>

        </React.Fragment>
      ) }

      {warrclaimState.activeStep === 2 && (
        <React.Fragment>

          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
            <Paper elevation={1} sx={{m:2,p:2}}>
            <Typography variant="subtitle2" component="span"> Πλαίσιο: </Typography>
            <Typography variant="body1" component="span">{warrclaimState.vin} </Typography>
            <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
            </Paper>
          </Box>

          {/* <Box>{`=== prtableupdate=${isPartsLoading}, rows=${prrows.length}, addprc=${addprcode} addprc=${addprqty}===`} </Box> */}
          <Paper elevation={1} sx={{m:2,p:1}}>

          <Typography variant="subtitle2" >Επιλογή και προσθήκη ανταλλακτικού</Typography>
          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
            <TextField id="add-part" label="κωδικος ανταλλακτικού" variant="outlined" size="small" value={addprcode} 
              onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setAddprcode(event.target.value); }}  
            />
            
            <TextField id="add-pqty" label="ποσότητα"  variant="outlined" size="small" value={addprqty}
              onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setAddprQty(event.target.value); }}  
            />
            <Fab color="primary" aria-label="add" size="small" onClick={()=>{addPrTotable();}}>
              <AddIcon />
            </Fab>
          </Box>
          </Paper>

          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
            
            <PartsDataGrid isLoading={isPartsLoading} rows={warrclaimState.prrows} cbfrowsdel={deleteRowsFromPrTable} />
            
          </Box>

          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' }, mt:3  }}  >

            <Paper elevation={1} sx={{m:2,p:1}}>
            <Typography variant="subtitle2" >Επιλογή και προσθήκη εργασίας</Typography>
            <Box sx={{ minWidth: 120 }}>

              {warrOpers && <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
              <InputLabel id="sel-labour-category-label">Ομάδα Εργασίας</InputLabel>
              <NativeSelect variant="standard"
              id="sel-labour-category"
              inputProps={{
                name: 'labour-category-inp',
                id: 'sel-labour-category-inp',
              }}
              value={opercateg}
              onChange={hChangeSelOpCateg}
              >
                <option  value="" > </option>
                {warrOpers?.filter( (oper) => oper[1].toString().substring(2,4)=="..")
                .map( (opcateg, index:number) =>  { 
                  let sval = `${opcateg[1]}`.substring(0,2)
                  let stitle = `${sval}-${opcateg[4]}`
                  let idx =`${index}`
                  // console.log('sval',sval,'idx',idx,'stitle',stitle)
                  return <option  value={sval} key={idx} >{stitle}</option>
                }) }
              </NativeSelect>
              </FormControl> }

              {warrOpers && <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
              <InputLabel id="sel-labour-label">Εργασία</InputLabel>
              <NativeSelect variant="standard"
              id="sel-labour"
              inputProps={{
                name: 'labour-inp',
                id: 'sel-labour-inp',
              }}
              value={operation}
              onChange={hChangeSelOperation}
              >
                <option  value="" > </option>
                {warrOpers.filter( (oper) => oper[1].toString().substring(2,4) !=".." && oper[1].toString().startsWith(opercateg) )
                .map( (operation, index:number) =>  { 
                  let sval = `${operation[1]}`
                  let stitle = `${sval}-${operation[4]}`
                  let idx =`${index}`
                  // console.log('sval',sval,'idx',idx,'stitle',stitle)
                  return <option  value={sval} key={idx} >{stitle}</option>
                }) }
              </NativeSelect>
              </FormControl> }

              <Fab color="primary" aria-label="add" size="small" onClick={()=>{addLabrTotable();}}>
                <AddIcon />
              </Fab>

            </Box>
            </Paper>

          </Box>
          
          <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
            <LaboursDataGrid isLabLoading={isLabLoading} rows={warrclaimState.labrows} cbfrowsdel={deleteRowsFromLabrTable} cbfrowupd={hUpdatedLabrRow} />
          </Box>

        </React.Fragment>
      ) }

      {warrclaimState.activeStep === 3 && (
        <>
        <Paper>
          
        <Box component="form" sx={{ '& .MuiTextField-root': { m: 1,  maxWidth: '90%' } }} noValidate autoComplete="off" >
            <TextField  id="custname"  label="Ονοματεπώνυμο"
              value={warrclaimState.custname}
              variant="standard"
              size="small"
              fullWidth
              required={warrclaimconfig?.custname.required}
              onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                //setFaultCode(event.target.value); 
                setWarrclaimstate({custname: event.target.value })
              }}
            />
        </Box>    
            

        {/* <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" > */}
          <Grid container spacing={2}>
          <Grid size={8}>
            <TextField  id="custaddr"  label="Διεύθυνση"
              value={warrclaimState.custaddr}
              variant="standard"
               size="small"
               fullWidth
               required={warrclaimconfig?.custaddr.required}
               sx={{marginLeft:1}}
               onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                //setFaultCode(event.target.value); 
                setWarrclaimstate({custaddr: event.target.value })
              }}
            />             
          </Grid>
          <Grid size={4}>
            <TextField  id="custzip"  label="Τ.Κ."
              value={warrclaimState.custzip}
              variant="standard"
               size="small"
               fullWidth
               required={warrclaimconfig?.custzip.required}
               onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                //setFaultCode(event.target.value); 
                setWarrclaimstate({custzip: event.target.value })
              }}
            />             
          </Grid>
          </Grid>

          <Grid container spacing={2}>
          <Grid size={6}>
            <TextField  id="custcity"  label="Πόλη"
              value={warrclaimState.custcity}
              variant="standard"
               size="small"
               fullWidth
               required={warrclaimconfig?.custcity.required}
               sx={{marginLeft:1}}
               onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                //setFaultCode(event.target.value); 
                setWarrclaimstate({custcity: event.target.value })
              }}
            />             
          </Grid>
          <Grid size={6}>
            <TextField  id="custcountry"  label="Χώρα"
              value={warrclaimState.custcountry}
              variant="standard"
               size="small"
               fullWidth
               required={warrclaimconfig?.custcountry.required}
               onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                //setFaultCode(event.target.value); 
                setWarrclaimstate({custcountry: event.target.value })
              }}
            />             
          </Grid>
          </Grid>

          <Grid container spacing={2}>
          <Grid size={6}>
            <TextField  id="custmobile"  label="Κινητό/Τηλ."
              value={warrclaimState.custmobile}
              variant="standard"
               size="small"
               fullWidth
               required={warrclaimconfig?.custmobile.required}
               sx={{marginLeft:1}}
               onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                //setFaultCode(event.target.value); 
                setWarrclaimstate({custmobile: event.target.value })
              }}
            />             
          </Grid>
          <Grid size={6}>
            <TextField  id="custemail"  label="e-mail"
              value={warrclaimState.custemail}
              variant="standard"
               size="small"
               fullWidth
               required={warrclaimconfig?.custemail.required}
               onKeyDown={e => e.key === 'Enter' && e.preventDefault()}
              onChange={ (event: React.ChangeEvent<HTMLInputElement>) => {
                //setFaultCode(event.target.value); 
                setWarrclaimstate({custemail: event.target.value })
              }}
            />             
          </Grid>
          </Grid>

        {/* </Box>           */}
        </Paper></>
      )}

      {warrclaimState.activeStep === 4 && (
        <>
        <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
              <Paper elevation={1} sx={{m:2,p:2}}>
              <Typography variant="subtitle2" component="span"> Πλαίσιο: </Typography>
              <Typography variant="body1" component="span">{warrclaimState.vin} </Typography>
              <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
              <Typography variant="subtitle2" component="span"> Τύπος προβλήματος  (ανταλλακτικό): </Typography>
              <Typography variant="body1" component="span">{warrclaimState.faultCode} </Typography>
              <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
              <Typography variant="subtitle2" component="span"> , Αιτία προβλήματος: </Typography>
              <Typography variant="body1" component="span">{warrclaimState.causeCode.code} </Typography>
              <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
              <Typography variant="body1" component="span"> ..... </Typography>
              <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography> 
              </Paper>
        </Box>
        <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
            Ανταλλακτικά
          </Typography>
          <Demo>
            <List dense={true}>
              {warrclaimState.prrows.map( (value,idx,arr) => { return(
                <ListItem>
                  <ListItemText key={value.id.toString()} primary={`${value.prcode}-${value.prname.substring(0,20)}... ${value.qty}`} />
                </ListItem>
              )} )}
            </List>
          </Demo>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
            Εργασίες
          </Typography>
          <Demo>
            <List dense={true}>
            {warrclaimState.labrows.map( (value,idx,arr) => { return(
                <ListItem>
                  <ListItemText key={value.id.toString()} primary={`${value.labcode}-${value.labelname.substring(0,20)}... ${value.labqty}`} />
                </ListItem>
              )} )}
            </List>
          </Demo>
        </Grid>
      </Grid>

      <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
              <Paper elevation={1} sx={{m:2,p:2}}>
              <Button variant="contained" endIcon={<SendIcon />} loading={isposting} disabled={disablePost}
                onClick={(e)=>{postWarrClaim()}}>Αποστολη</Button>
              <div>
              <Typography variant="body2" component="span">Μετά την αποστολή (καταχώριση) δεν επιτρέπονται αλλαγές. Πρέπει μόνο να προσθέσετε φωτογραφίες στο επόμενο βήμα.</Typography>
              </div>
              <div>
              { (warrclaimState.warrclaimdocid>0) ? (<Typography variant="body1" component="span">
                Επιτυχής καταχώριση. Κωδικός Δελτίου Εγγύησης:{` ${warrclaimState.warrclaimdoccode}`}
                </Typography>) : (<Typography variant="body1" component="span">
                  {` `}
                </Typography>)
              }
              </div>
              </Paper>
        </Box>

      </>) }

      {/* <form name="fromattachements" autoComplete="off" method="post" onSubmit={handleUploadClick}> 
        <!-- MAX_FILE_SIZE must precede the file input field --> 
        <input type="hidden" name="MAX_FILE_SIZE" value="30000" />
        <input type="submit" value="Submit"/>
      </form> */}
      {warrclaimState.activeStep === 5 && warrclaimState.warrclaimdocid>0 && (
        <>
        <Box component="form" sx={{ '& .MuiTextField-root': { m: 1, width: 500, maxWidth: '100%' } }} noValidate autoComplete="off" >
              <Paper elevation={1} sx={{m:2,p:2}}>
              <Typography variant="subtitle2" component="span"> Πλαίσιο: </Typography>
              <Typography variant="body1" component="span">{warrclaimState.vin} </Typography>
              <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
              <Typography variant="subtitle2" component="span"> Τύπος προβλήματος  (ανταλλακτικό): </Typography>
              <Typography variant="body1" component="span">{warrclaimState.faultCode} </Typography>
              <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
              <Typography variant="subtitle2" component="span"> , Αιτία προβλήματος: </Typography>
              <Typography variant="body1" component="span">{warrclaimState.causeCode.code} </Typography>
              <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography>
              <Typography variant="body1" component="span"> ..... </Typography>
              <Typography variant="subtitle2" component="span"><OkMark>✔</OkMark></Typography> 
              <div>
              { (warrclaimState.warrclaimdocid>0) ? (<Typography variant="body1" component="span">
                Κωδικός Δελτίου Εγγύησης:{` ${warrclaimState.warrclaimdoccode}`}
                </Typography>) : (<Typography variant="body1" component="span">
                  {` `}
                </Typography>)
              }
              </div>
              </Paper>
        </Box>
        <UploadImages warrclaimdocid={warrclaimState.warrclaimdocid} clientid={auth.userData.token} usercode={auth.userData.username}
          namepart={warrclaimState.vin} uplsource="b2bksrwarrclaim" />
        </>
      )}

      {warrclaimState.activeStep === steps.length ? (
        <Alert variant="outlined" severity="info">
          <Typography sx={{ mt: 2, mb: 1 }}>
            All steps completed - you&apos;re finished
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        </Alert>
      ) : (

        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, justifyContent: 'space-between' }}>

        <div >
        <Typography sx={{mr:2}}>{'   '}</Typography>
        </div>

          <div>
            <Button onClick={handleReset}>
              Reset
            </Button>
          </div>

        <div>
        <Button
          color="inherit"
          disabled={warrclaimState.activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1 }}
        >
          Back
        </Button>
        </div>
        {/* <Box sx={{ flex: '1 1 auto' }} > */}
        {/* {isStepOptional(warrclaimstate.activeStep) && (
          <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
            Skip
          </Button>
        )} */}
        <div>
        <Button onClick={handleNext}>
          {warrclaimState.activeStep === steps.length - 1 ? 'Finish' : 'Next'}
        </Button>
        </div>

      </Box>
      )}

      <div>
        {/* {`DEBUG vin=[${warrclaimState.vin}] warrclaimdocid=[${warrclaimState.warrclaimdocid}] warrclaimdoccode=[${warrclaimState.warrclaimdoccode}] prrows=[${warrclaimState.prrows.length}]`}
        {` labrows=[${warrclaimState.labrows.length}] warrdate=[${warrclaimState.warrdate}]`}
       */}
       {'   '}
      </div>
    </Box>)

    }
}

// ?.format("YYYY-MM-DD")

interface LabourTableProps {
  isLabLoading:  boolean;
  rows: (typeof laborexample)[]
  cbfrowsdel: Function
  cbfrowupd: Function
}

// <(typeof laborexample)>
const labrtablecolumns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'labcode',
    headerName: 'Κωδ.Εργ.',
    width: 100,
    editable: false,
    sortable: false,
    hideable: false,
  },
  {
    field: 'labelname',
    headerName: 'Περιγραφή',
    width: 180,
    editable: false,
    sortable: false,
    hideable: false,
  },
  {
    field: 'labqty',
    type: 'number',
    width: 100,
    editable: true,
    sortable: false,
    hideable: false,
    renderHeader: (params: GridColumnHeaderParams) => (
      <strong>{'Ωρες '}<span role="img" aria-label="edit">✏️</span></strong>
    ),
    // valueGetter: (value, row) => {
    //   if(!value) return null;
    //   if(isNaN(parseFloat(value))) return null;
    //   if(parseFloat(value)<=0) return null;
    //   return value;
    // },
  },
  {
    field: 'labnotes',
    type: 'string',
    flex:  1,
    editable: true,
    sortable: false,
    hideable: false,
    renderHeader: (params: GridColumnHeaderParams) => (
      <strong>{'Περιγραφή '}<span role="img" aria-label="edit">✏️</span></strong>
    ),
  },
];


function LaboursDataGrid(props:LabourTableProps){
  //const [rows,Setrows]= React.useState(props.rows)
  
  // for single click editing ...
  const [cellModesModel, setCellModesModel] = React.useState<GridCellModesModel>({});

  const [checkboxSelection, setCheckboxSelection] = React.useState(true);
  const [disableMultipleRowSelection, setDisableMultipleRowSelection] = React.useState(true);
  const [deleteButtonOn, SetdeletebuttonOn] = React.useState(false);
  const [rowSelectionModel, setRowSelectionModel] = React.useState<GridRowSelectionModel>({ type: 'include', ids: new Set() });

  // for single click editing ...
  const handleCellClick = React.useCallback(
    (params: GridCellParams, event: React.MouseEvent) => {
      if (!params.isEditable) {
        return;
      }

      // Ignore portal
      if (
        (event.target as any).nodeType === 1 &&
        !event.currentTarget.contains(event.target as Element)
      ) {
        return;
      }

      setCellModesModel((prevModel) => {
        return {
          // Revert the mode of the other cells from other rows
          ...Object.keys(prevModel).reduce(
            (acc, id) => ({
              ...acc,
              [id]: Object.keys(prevModel[id]).reduce(
                (acc2, field) => ({
                  ...acc2,
                  [field]: { mode: GridCellModes.View },
                }),
                {},
              ),
            }),
            {},
          ),
          [params.id]: {
            // Revert the mode of other cells in the same row
            ...Object.keys(prevModel[params.id] || {}).reduce(
              (acc, field) => ({ ...acc, [field]: { mode: GridCellModes.View } }),
              {},
            ),
            [params.field]: { mode: GridCellModes.Edit },
          },
        };
      });
    },
    [],
  );
  const handleCellModesModelChange = React.useCallback(
    (newModel: GridCellModesModel) => {
      setCellModesModel(newModel);
    },
    [],
  );

  function processLabrRowUpdate(updatedRow:(typeof laborexample), originalRow:(typeof laborexample)) {
    console.log('processLabrRowUpdate called with updatedRow=',updatedRow," originalRow=",originalRow)
    if(isNaN(updatedRow.labqty)) return;
    if(updatedRow.labqty<=0) return;
    console.log('processLabrRowUpdate will continue with updatedRow=',updatedRow)
    props.cbfrowupd(updatedRow)
    // return updatedRow
  }
    
  // function onRowSelectionMoChange(rowSelectionModel: GridRowSelectionModel, details: GridCallbackDetails){
  //   console.log("== onRowSelectionMoChange, rowSelectionModel=",rowSelectionModel," ,details=",details)
  //   // todo fix this
  //   // if(rowSelectionModel.length>0){
  //   //   Setselectedrows(rowSelectionModel)
  //   //   SetdeletebuttonOn(true)
  //   // }
  // }

  function removeSelected()
  {
    if(rowSelectionModel.ids.size>0){
      let ardelids:GridRowId[]=[]
      rowSelectionModel.ids.forEach( (item)=>{
        ardelids.push(item)
      })
      console.log("for deletion ids=",ardelids)
      props.cbfrowsdel(ardelids)
    }
  }

  React.useEffect( ()=>{
    if(rowSelectionModel.ids.size>0) SetdeletebuttonOn(true);
    else SetdeletebuttonOn(false);
  },[rowSelectionModel.ids.size])

  return(
    <Box sx={{width: '100%' }}>

      <Box sx={{ flexGrow: 1 }}>

        <Grid container sx={{ justifyContent: 'center' }}>
          <Grid size={6}>
            {/* <Tooltip title="Ανταλλακτικά" placement="left"> */}
              <Button>Εργασίες{` (${props.rows.length})`}</Button>
            {/* </Tooltip> */}
          </Grid>
          <Grid container direction="column" sx={{ alignItems: 'flex-end' }} size={6}>
            <Grid>
            { (deleteButtonOn) ? (
              <Tooltip title="Διαγραφή επιλεγμένων" placement="right" onClick={()=>removeSelected()}>
                <DeleteIcon />
              </Tooltip>
            ) : (
              <Tooltip title="-" placement="right">
              <Button>-</Button>
            </Tooltip>
            ) }
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Typography  variant="subtitle2" gutterBottom >Συμπληρώστε Ωρες με διπλό κλικ στο κελί. Προσοχή: Τα δεκαδικά στις Ωρες με τελεία `.` όχι κόμα `,` - Διπλό κλικ στο κελί Περιγραφή για συμπλήρωση περιγραφής </Typography>
      
      <Box sx={{ height: 200, width: '100%',
        [`.${gridClasses.cell}.cold`]: {
          backgroundColor: '#b9d5ff91',
          color: '#1a3e72',
        },
        [`.${gridClasses.cell}.hot`]: {
          backgroundColor: '#ff943975',
          color: '#1a3e72',
        }, 
        [`.${gridClasses.cell}.editable`]: {
          backgroundColor: '#FFFAF0',
          color: '#000000',
          border: '1px solid red'
        },}}>
      <DataGrid
        rows={props.rows}
        columns={labrtablecolumns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        getCellClassName={(params: GridCellParams<any, any, number>) => {
          if (params.field === 'labqty' || params.field === 'labnotes') {
            return 'editable';
          }
          return '' ;
        }}
        getRowId={(row) => row.id}
        pageSizeOptions={[5]}
        checkboxSelection={checkboxSelection}
        disableMultipleRowSelection={disableMultipleRowSelection}
        disableRowSelectionOnClick
        disableColumnSelector 
        disableColumnFilter={true}
        disableColumnMenu 
        columnVisibilityModel={{
          // Hide columns id and traderName, the other columns will remain visible
          id: false,
        }}
        // onRowSelectionModelChange={onRowSelectionMoChange}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
        rowSelectionModel={rowSelectionModel}
        density="compact"
        processRowUpdate={processLabrRowUpdate}
        cellModesModel={cellModesModel}
        onCellModesModelChange={handleCellModesModelChange}
        onCellClick={handleCellClick}
        sx={{
          // backgroundColor: (theme) => "gray",
          width: "100%",
          "& .MuiDataGrid-columnHeader:not(:first-child):not(:last-child)": {
            mx: 1
          },
          "& .MuiDataGrid-columnHeader:first-child:not(:last-child)": {
            mr: 1
          },
          "& .MuiDataGrid-columnHeader:last-child:not(:first-child)": {
            ml: 1
          },
          "& .MuiDataGrid-cell:not(:first-child):not(:last-child)": {
            mx: 1
          },
          "& .MuiDataGrid-cell:first-child:not(:last-child)": {
            mr: 1
          },
          "& .MuiDataGrid-cell:last-child:not(:first-child)": {
            ml: 1
          }
        }}
      />
      </Box>

    </Box>

  )
}
/*sx={{
          backgroundColor: (theme) => "gray",
          width: "80%",
          "& .MuiDataGrid-columnHeader:not(:first-child):not(:last-child)": {
            mx: 3
          },
          "& .MuiDataGrid-columnHeader:first-child:not(:last-child)": {
            mr: 3
          },
          "& .MuiDataGrid-columnHeader:last-child:not(:first-child)": {
            ml: 3
          },
          "& .MuiDataGrid-cell:not(:first-child):not(:last-child)": {
            mx: 3
          },
          "& .MuiDataGrid-cell:first-child:not(:last-child)": {
            mr: 3
          },
          "& .MuiDataGrid-cell:last-child:not(:first-child)": {
            ml: 3
          },
          "& .MuiDataGrid-row": {
            mt: 3
          }
        }}
  */

interface PartsTableProps {
  isLoading: boolean;
  rows: (typeof prtestrows)[number][]
  cbfrowsdel: Function
}

const prtestrows = [
  { id: 1, prcode: 'prcode', prname: 'prname', qty: 1.1 },
];

const prtablecolumns: GridColDef<(typeof prtestrows)[number]>[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'prcode',
    headerName: 'Part code',
    width: 150,
    editable: false,
    sortable: false,
    hideable: false,
  },
  {
    field: 'prname',
    headerName: 'Part name',
    width: 150,
    editable: false,
    sortable: false,
    hideable: false,
  },
  {
    field: 'qty',
    headerName: 'Qty',
    type: 'number',
    width: 110,
    editable: false,
    sortable: false,
    hideable: false,
  },
  // {
  //   field: 'fullName',
  //   headerName: 'Full name',
  //   description: 'This column has a value getter and is not sortable.',
  //   sortable: false,
  //   width: 160,
  //   valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
  // },
];
/*density
Set the density of the Data Grid.
Type:'comfortable'
| 'compact'
| 'standard'
Default:"standard"

onRowSelectionModelChange
Callback fired when the selection state of one or multiple rows changes.

Type:func
Signature:
function(rowSelectionModel: GridRowSelectionModel, details: GridCallbackDetails) => void
    rowSelectionModel With all the row ids GridSelectionModel.
    details Additional details for this callback.

*/
function PartsDataGrid(props:PartsTableProps) {
  const [rows,Setrows]= React.useState(props.rows)
  const [checkboxSelection, setCheckboxSelection] = React.useState(true);
  const [disableMultipleRowSelection, setDisableMultipleRowSelection] = React.useState(true);
  const [deleteButtonOn, SetdeletebuttonOn] = React.useState(false);
  // const [selectedrows, Setselectedrows] = React.useState<GridRowSelectionModel>([]);
  // const [selectedrows, Setselectedrows] = React.useState<GridRowSelectionModel>({ type: 'include', ids: new Set() });

  const [rowSelectionModel, setRowSelectionModel] =
    React.useState<GridRowSelectionModel>({ type: 'include', ids: new Set() });

  // TRIALS WITJ DATAGRID API
  const [gridmessage, setGridmessage] = React.useState('');
  // for mui-x datagrid api
  const apiRef = useGridApiRef();

  // const handleRowClick: GridEventListener<'rowClick'> = (params) => {
  //   setGridmessage(`Movie "${params.row.prname}" clicked`);
  // };


  // const heRowSelectionChange: GridEventListener<'rowSelectionChange'> = (
  //   params,  // GridRowSelectionModel
  //   event,   // MuiEvent<{}>
  //   details, // GridCallbackDetails
  // ) => {
  //   console.log("ON_rowSelectionChange, GridRowSelectionModel=",JSON.stringify(params)," GridCallbackDetails=",details, " MuiEvent=",event)
  // }
  //      if(apiRef && apiRef.current!==null) apiRef.current.subscribeEvent('rowSelectionChange', heRowSelectionChange);

  // apiRef.current?.getSelectedRows
  // apiRef.current.
  // Use gridRowSelectionIdsSelector, gridRowSelectionCountSelector, or gridRowSelectionManagerSelector instead.

  // const heRowSelectionCheckboxChange: GridEventListener<'rowSelectionCheckboxChange'> = (
  //   params,  // GridRowSelectionCheckboxParams
  //   event,   // MuiEvent<React.ChangeEvent<HTMLElement>>
  //   details, // GridCallbackDetails
  // ) => {
  //   console.log("rowSelectionCheckboxChange, GridRowSelectionCheckboxParams=",JSON.stringify(params)," GridCallbackDetails=",details, " MuiEvent=",event)
  // }
  //  if(apiRef && apiRef.current!==null) apiRef.current.subscribeEvent('rowSelectionCheckboxChange', heRowSelectionCheckboxChange);


  // function onRowSelectionMoChange(rowSelectionModel: GridRowSelectionModel, details: GridCallbackDetails){
  //   console.log("=JS WarrantyClaim=, onRowSelectionMoChange, rowSelectionModel=",rowSelectionModel)

  //   const visibleRows = gridPaginatedVisibleSortedGridRowIdsSelector(apiRef);
  //   console.log("=JS WarrantyClaim=, onRowSelectionMoChange, gridPaginatedVisibleSortedGridRowIdsSelector.length=",visibleRows.length)
  //   if (visibleRows.length === 0) {
  //     return;
  //   }
  //   /*  PROGRMMATICALLY SELECT 1ST ROW:
  //     apiRef.current?.selectRow(
  //     visibleRows[0],
  //     !apiRef.current.isRowSelected(visibleRows[0]),
  //   )*/

  //   // rowSelectionModel={ type: "include", ids: Set(1) }

  //   // todo fix this
  //   // if(rowSelectionModel.length>0){
  //   //   Setselectedrows(rowSelectionModel)
  //   //   SetdeletebuttonOn(true)
  //   // }
  // }

  function removeSelected()
  {
    // todo fix this 
    // if(selectedrows.length<=0) return;
    // props.cbfrowsdel(selectedrows)
    if(rowSelectionModel.ids.size>0){
      let ardelids:GridRowId[]=[]
      rowSelectionModel.ids.forEach( (item)=>{
        ardelids.push(item)
      })
      console.log("for deletion ids=",ardelids)
      props.cbfrowsdel(ardelids)
    }
  }

  React.useEffect( ()=>{
    if(rowSelectionModel.ids.size>0) SetdeletebuttonOn(true);
    else SetdeletebuttonOn(false);
  },[rowSelectionModel.ids.size])

  // console.log(" rowSelectionModel=",rowSelectionModel, ' size=', rowSelectionModel.ids.size)
  // if(rowSelectionModel.ids.size>0){
  //   rowSelectionModel.ids.forEach( (item)=>{
  //     console.log("id=",item);
  //   })
  // }

  return (
    <Box sx={{ width: '100%' }}>

      <Box sx={{ flexGrow: 1 }}>

        <Grid container sx={{ justifyContent: 'center' }}>
          <Grid size={6}>
            {/* <Tooltip title="Ανταλλακτικά" placement="left"> */}
              <Button>Ανταλλακτικά{` (${props.rows.length})`}</Button>
            {/* </Tooltip> */}
          </Grid>
          <Grid container direction="column" sx={{ alignItems: 'flex-end' }} size={6}>
            <Grid>
            { (deleteButtonOn) ? (
              <Tooltip title="Διαγραφή επιλεγμένων" placement="right" onClick={()=>removeSelected()}>
                <DeleteIcon />
              </Tooltip>
            ) : (
              <Tooltip title="-" placement="right">
              <Button>-</Button>
            </Tooltip>
            ) }
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ height: 200, width: '100%' }}>
      <DataGrid
        rows={props.rows}
        columns={prtablecolumns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        getRowId={(row) => row.id}
        apiRef={apiRef}
        pageSizeOptions={[5]}
        checkboxSelection={checkboxSelection}
        disableMultipleRowSelection={disableMultipleRowSelection}
        disableRowSelectionOnClick
        disableColumnSelector 
        disableColumnFilter={true}
        disableColumnMenu 
        columnVisibilityModel={{
          // Hide columns id and traderName, the other columns will remain visible
          id: false,
        }}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
        rowSelectionModel={rowSelectionModel}
        // onRowSelectionModelChange={onRowSelectionMoChange}
        density="compact"
      />
      <div>{gridmessage}</div>
      </Box>
    </Box>
  );
}

/* ΕΙΔΟΣ ΒΛΑΒΗΣ: .....ΧΧΧΧΧΧ.....    (κωδικός ανταλλακτικού, ελέγχεται αν υπάρχει στη βάση ο κωδικός)
ΑΙΤΙΑ ΒΛΑΒΗΣ:  ....ΧΧΧΧΧΧΧΧ... <DROPDOWN LIST>  (περιμένω λίστα από ΑΙΤΙΕΣ ΒΛΑΒΗΣ)
ΠΕΡΙΓΡΑΦΗ ΠΕΡΙΣΤΑΤΙΚΟΥ: ....μπλα μπλα ................ <TEXTAREA>
ΠΙΝΑΚΑΣ ΑΝΤΑΛΛΑΚΤΙΚΩΝ
1. ΚΩΔΙΚΟΣ1 ΧΧΧΧΧΧΧΧ  ΠΟΣΟΤΗΤΑ: 1  (ελέγχεται αν υπάρχει στη βάση ο κωδικός)
2. ΚΩΔΙΚΟΣ2 ΧΧΧΧΧΧΧΧ  ΠΟΣΟΤΗΤΑ: 2 (ελέγχεται αν υπάρχει στη βάση ο κωδικός)
....
ΠΙΝΑΚΑΣ ΕΡΓΑΣΙΩΝ
1. ΕΡΓΑΣΙΑ1: χχχχχχχχ (πληκρολογείται)   ΠΟΣΟΤΗΤΑ: 0.4 
2. ΕΡΓΑΣΙΑ2: χχχχχχχχ (πληκρολογείται)   ΠΟΣΟΤΗΤΑ: 1.5

ΕΠΙΣΥΝΑΨΗ 1 ΦΩΤΟΓΡΑΦΙΑΣ ??????
*/